var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3096 5.34478L17.1904 1.24897C16.7483 0.809435 16.1488 0.562503 15.5237 0.5625H2.35714C1.05531 0.5625 0 1.61182 0 2.90625V20.0938C0 21.3882 1.05531 22.4375 2.35714 22.4375H19.6429C20.9447 22.4375 22 21.3882 22 20.0938V7.00205C22 6.38045 21.7517 5.78431 21.3096 5.34478ZM11 19.3125C9.26426 19.3125 7.85714 17.9134 7.85714 16.1875C7.85714 14.4616 9.26426 13.0625 11 13.0625C12.7357 13.0625 14.1429 14.4616 14.1429 16.1875C14.1429 17.9134 12.7357 19.3125 11 19.3125ZM15.7143 4.44336V9.35156C15.7143 9.67515 15.4504 9.9375 15.125 9.9375H3.73214C3.40671 9.9375 3.14286 9.67515 3.14286 9.35156V4.27344C3.14286 3.94985 3.40671 3.6875 3.73214 3.6875H14.9541C15.1104 3.6875 15.2603 3.74922 15.3708 3.85913L15.5417 4.02905C15.5964 4.08345 15.6398 4.14804 15.6694 4.21913C15.6991 4.29022 15.7143 4.36641 15.7143 4.44336Z",
    fill: "#22304E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f46f36e99329b9d146bec55f2723978d.svg";
export { ForwardRef as ReactComponent };